"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const mui_inputs_image_firebase_1 = require("@dzambalaorg/mui-inputs-image-firebase");
const validation_1 = require("./validation");
const PromoDialogForm = (props) => {
    const { selectedItem, open, mode, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, title, productId, imageUrl } = selectedItem;
    const fixedValues = { id, title, productId, imageUrl };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, validationSchema: validation_1.validationSchema, initialValues: fixedValues, message: `dialogs.${mode}`, ...rest, children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "title" }), (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "productId", controller: "products" }), (0, jsx_runtime_1.jsx)(mui_inputs_image_firebase_1.AvatarInput, { name: "imageUrl" })] }));
};
exports.PromoDialogForm = PromoDialogForm;
//# sourceMappingURL=index.js.map